module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (159).1298cf22.jpg";